export const API_TIMEOUT_CODE = 'ECONNABORTED';